import { createAsyncThunk } from "@reduxjs/toolkit";
import { IChoiceMerchant } from "models/Login/choiceMerchant.model";

import { Merchant } from "services/merchant.service";

export const merchantAsync = createAsyncThunk(
  "merchant",
  async (): Promise<IChoiceMerchant> => {
    try {
      const response = await Merchant();
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
